import { ScreenReaderOnly } from './ScreenReaderOnly'

export enum ScreenReaderAlertPoliteness {
  ASSERTIVE = 'assertive',
  POLITE = 'polite',
  OFF = 'off',
}
interface IProps extends React.HTMLProps<HTMLSpanElement> {
  politeness?: ScreenReaderAlertPoliteness
  visible?: boolean
}

/**
 *
 */
export const ScreenReaderAlert: React.FunctionComponent<IProps> = ({
  children,
  politeness = ScreenReaderAlertPoliteness.ASSERTIVE,
  visible = false,
}: IProps) => {
  return visible ? (
    <span role="alert" aria-live={politeness}>
      {children}
    </span>
  ) : (
    <ScreenReaderOnly role="alert" aria-live={politeness}>
      {children}
    </ScreenReaderOnly>
  )
}
